import { Component, OnInit } from '@angular/core';
import { ProductCode } from './../../shared/utilities/product-code';

@Component({
  selector: 'fgb-badges-page',
  templateUrl: './badges-page.component.html',
  styleUrls: ['./badges-page.component.scss'],
})
export class BadgesPageComponent implements OnInit {
  productCode = ProductCode;
  constructor() {}

  ngOnInit(): void {}
}
